import { ButtonHTMLAttributes, ReactNode } from 'react';
import style from './ui.module.css';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'white' | 'primary' | 'outline';
  className?: string;
  disabled?: boolean;
}

const Button = ({ children, variant = 'white', className = '', disabled = false, type = 'button', onClick, ...props }: ButtonProps) => {
  const baseStyles = `${style['button-style']}`;

  const variants = {
    primary: 'bg-(--font-primary) text-white',
    white: 'bg-(--surface-action)',
    outline: 'bg-(--surface-base) border border-(--border-main) text-(--font-primary) !rounded-lg !h-9 !px-3 !min-w-0 body-sm-semibold',
  };
  return (
    <button type={type} className={`${baseStyles} ${variants[variant]} ${className}`} disabled={disabled} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;
